module.exports = __webpack_public_path__ + "img/7ff7887.png";